import axios from "axios";
import { api } from "../../api";
// viewwe 
export const userView = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/viewers`,
      { withCredentials: true }
    );
    console.log(response);
  } catch (error) {
    console.log(error.response);
  }
};

// alllength

export const allLength = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/all-length`
    );

    dispatch({
      type: "LENGTH_GET_SUCCESS",
      payload: {
        users: response.data.users,
        blogs:response.data.blogs,
        portfolios:response.data.portfolios,
        messages:response.data.messages,
        pricings:response.data.pricings,
        userView:response.data.userView,
        orders:response.data.orders

      },
    });
  } catch (error) {
    console.log(error.response);
  }
};